/* eslint-disable import/no-unresolved,react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useReducer, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isBrowser, isIOS, isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import { WhitelistAddExternalComponent } from 'assets/components';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import Input from '../../../../components/Input';
import {
  validateInputLength,
  validateLatinLettersOnly,
} from '../../../../utilities/formValidation';
import { clearFormError } from '../../../../utilities/formsUtils';

const WhitelistAddExternal = ({ openScreen, wallet, options, isSendCryptoFlow }) => {
  const { t: translate } = useTranslation();
  const form = {
    address: '',
    coin: wallet.coin,
    coin_id: wallet.coin_id,
    name: '',
    memo: '',
    beneficiary_first_name: '',
    beneficiary_last_name: '',
  };
  const [wallets, setWallets] = useState([{ ...form }]);
  const [formValidityState, setFormValidityState] = useReducer(
    (prev, next) => ({ ...prev, ...next }),
    {
      validLength: false,
      validBeneficiaryFirstName: false,
      validBeneficiaryLastName: false,
    }
  );

  const prevScreen = useMemo(() => {
    if (options?.prevScreen) {
      return options?.prevScreen;
    }
    if (isSendCryptoFlow) {
      return SendCryptoScreensFlow.SEND_CRYPTO;
    }
    return SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES;
  }, [isSendCryptoFlow, options]);

  const isMemoAvailable = useMemo(() => {
    const addressArr = wallet?.address?.split('?dt=');

    return addressArr?.length > 1;
  }, [wallet]);

  const submit = () => {
    if (!wallets.length) {
      return false;
    }
    const _wallets = [];

    wallets.forEach((w) => {
      if (w.address && w.name) {
        _wallets.push(w);
      }
    });

    openScreen(SendCryptoScreensFlow.WHITELIST_VERIFY, { wallets: _wallets });

    return true;
  };

  const handleAddressOnchange = (e, index) => {
    const { value } = e.target;

    if (!validateInputLength(e.target.value, 25)) {
      if (e.target.className.indexOf('has-error') === -1) {
        e.target.className += ' has-error';
      }
    } else {
      clearFormError(e);
    }
    setFormValidityState({ validLength: validateInputLength(e.target.value, 25) });
    const _wallets = [...wallets];
    _wallets[index].name = value;
    setWallets(_wallets);
  };

  const handleFirstLastNameOnChange = (e, index) => {
    if (!e || !e?.target) return;

    const { value, name } = e.target;

    if (!validateLatinLettersOnly(value)) {
      if (e.target.className.indexOf('has-error') === -1) {
        e.target.className += ' has-error';
      }
    } else {
      clearFormError(e);
    }
    const _wallets = [...wallets];

    if (name === 'first_name') {
      _wallets[index].beneficiary_first_name = value;
      setFormValidityState({ validBeneficiaryFirstName: validateLatinLettersOnly(value) });
    }

    if (name === 'last_name') {
      _wallets[index].beneficiary_last_name = value;
      setFormValidityState({ validBeneficiaryLastName: validateLatinLettersOnly(value) });
    }

    setWallets(_wallets);
  };

  const renderTitle = () => (
    <div
      className={`w-100 ${
        isBrowser ? 'd-flex align-items-center justify-content-between mb-4' : ''
      } `}>
      <div>
        <b className="text-f5 text-dark ms-2">
          {translate('whitelist_add_address_external').replace('%s', wallet?.coin?.toUpperCase())}
        </b>
      </div>
    </div>
  );

  const renderFooter = () => (
    <button
      onClick={submit}
      disabled={
        !wallets[0]?.address ||
        !wallets[0]?.name ||
        !formValidityState?.validLength ||
        !formValidityState?.validBeneficiaryFirstName ||
        !formValidityState?.validBeneficiaryLastName
      }
      className="btn btn-primary text-light w-100 mt-auto"
      type="submit">
      {translate('confirm_button_label')}
    </button>
  );

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => openScreen(prevScreen)}
      renderTitle={renderTitle}
      renderFooter={renderFooter}>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        {wallets.map((w, i) => (
          <WhitelistAddExternalComponent key={`${w.wallet_address}-${i}`}>
            <div className="d-flex flex-row align-items-center mt-2">
              <div className="text-f5">
                {i !== 0
                  ? `${translate('whitelist_add_external_title')}  #${i + 1}`
                  : translate('whitelist_add_external_title')}
              </div>
              {wallets.length > 1 && (
                <i
                  aria-label="trash click"
                  onKeyDown={null}
                  tabIndex={-1}
                  role="button"
                  onClick={() => {
                    if (wallets.length > 1) {
                      const _wallets = [...wallets];
                      _wallets.splice(i, 1);
                      setWallets(_wallets);
                    }
                  }}
                  className="icon icon-trash ms-auto text-shadow text-f4"
                  style={{ width: '1rem', height: '1rem' }}
                />
              )}
            </div>
            <Input
              key="name"
              groupClassName={`mt-4 mb-0 ${isIOS ? 'ios' : ''}`}
              className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
              placeholder={translate('whitelist_add_external_enter_name')}
              label={translate('whitelist_add_external_enter_name')}
              errorLabel={translate('address_input_error_label')}
              name="cryptoName"
              onChange={(e) => handleAddressOnchange(e, i)}
              value={wallets[i].name}
              withFloatingLabel
              withErrorLabel
            />
            <Input
              key="address"
              groupClassName={`mt-5 mb-0 ${isIOS ? 'ios' : ''}`}
              className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
              placeholder={translate('whitelist_add_external_enter_address')}
              label={translate('whitelist_add_external_enter_address')}
              onChange={(e) => {
                const { value } = e.target;
                const _wallets = [...wallets];
                _wallets[i].address = value;
                setWallets(_wallets);
              }}
              value={wallets[i].address}
              withFloatingLabel
            />
            <Input
              containerClass="w-100"
              groupClassName={`mt-5 mb-0 ${isIOS ? 'ios' : ''}`}
              className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
              placeholder={translate('beneficiary_first_name_label')}
              label={translate('beneficiary_first_name_label')}
              errorLabel={
                !wallets[i].beneficiary_first_name
                  ? translate('input_required_error_label')
                  : translate('valid_letter_error_label')
              }
              name="first_name"
              value={wallets[i].beneficiary_first_name}
              onChange={(e) => handleFirstLastNameOnChange(e, i)}
              withFloatingLabel
              withErrorLabel
            />
            <Input
              containerClass="w-100"
              groupClassName={`mt-5 ${isMemoAvailable ? 'mb-0' : 'mb-3'} ${isIOS ? 'ios' : ''}`}
              className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
              placeholder={translate('beneficiary_last_name_label')}
              label={translate('beneficiary_last_name_label')}
              errorLabel={
                !wallets[i].beneficiary_last_name
                  ? translate('input_required_error_label')
                  : translate('valid_letter_error_label')
              }
              name="last_name"
              value={wallets[i].beneficiary_last_name}
              onChange={(e) => handleFirstLastNameOnChange(e, i)}
              withFloatingLabel
              withErrorLabel
            />
            {isMemoAvailable && (
              <Input
                key="memo"
                groupClassName={`mt-5 mb-0 ${isIOS ? 'ios' : ''}`}
                className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
                placeholder={translate('whitelist_add_external_enter_memo')}
                label={translate('whitelist_add_external_enter_memo')}
                onChange={(e) => {
                  const { value } = e.target;
                  const _wallets = [...wallets];
                  _wallets[i].memo = value;
                  setWallets(_wallets);
                }}
                value={wallets[i].memo}
                withFloatingLabel
              />
            )}
          </WhitelistAddExternalComponent>
        ))}
        <div className="mt-4 w-100">
          <div className="alert alert-info" role="alert">
            <i className="icon icon-info-icon" />
            <span className="content">
              <Trans
                i18nKey="beneficiary_note"
                components={[<span key="beneficiary key" className="text-bold" />]}
              />
            </span>
          </div>
        </div>
        {isMemoAvailable && (
          <div className="mt-4 w-100">
            <div className="alert alert-info" role="alert">
              <i className="icon icon-info-icon" />
              <span className="content">{translate('whitelist_add_external_note')}</span>
            </div>
          </div>
        )}
        <div
          onClick={() => {
            setWallets([...wallets, { ...form }]);
          }}
          tabIndex={-1}
          role="button"
          onKeyDown={null}
          className="cursor-pointer text-primary text-bold text-f5">
          + Add address
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default WhitelistAddExternal;

WhitelistAddExternal.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.object.isRequired,
  isSendCryptoFlow: PropTypes.bool,
  options: PropTypes.object,
};

WhitelistAddExternal.defaultProps = {
  options: {},
  isSendCryptoFlow: false,
};
